import {action, computed, makeObservable, observable} from "mobx";

export class SelectionStore {
    selectedFolders = [];
    selectedDocuments = [];
    syncCallbacks = {
        folders: [],
        documents: []
    };

    constructor() {
        makeObservable(this, {
            selectedFolders: observable,
            selectedDocuments: observable,
            syncCallbacks: observable,
            toggleFolderSelection: action,
            toggleDocumentSelection: action,
            clearSelections: action,
            registerSyncCallback: action,
            unregisterSyncCallback: action,
            countSelectedDocuments: computed,
            countSelectedFolders: computed
        });
    }

    // Selection Actions
    toggleFolderSelection = (folderId) => {
        if (this.selectedFolders.includes(folderId)) {
            this.selectedFolders = this.selectedFolders.filter(id => id !== folderId);
        } else {
            this.selectedFolders = [...this.selectedFolders, folderId];
        }
    };

    toggleDocumentSelection = (documentId) => {
        if (this.selectedDocuments.includes(documentId)) {
            this.selectedDocuments = this.selectedDocuments.filter(id => id !== documentId);
        } else {
            this.selectedDocuments = [...this.selectedDocuments, documentId];
        }
    };

    clearSelections = () => {
        this.selectedFolders = [];
        this.selectedDocuments = [];
        this.notifySyncCallbacks();
    };

    // Callback management
    registerSyncCallback = (type, callback) => {
        if (type === 'folder') {
            this.syncCallbacks.folders.push(callback);
        } else if (type === 'document') {
            this.syncCallbacks.documents.push(callback);
        }
    };

    unregisterSyncCallback = (type, callback) => {
        if (type === 'folder') {
            this.syncCallbacks.folders = this.syncCallbacks.folders.filter(cb => cb !== callback);
        } else if (type === 'document') {
            this.syncCallbacks.documents = this.syncCallbacks.documents.filter(cb => cb !== callback);
        }
    };

    // Notify all registered callbacks
    notifySyncCallbacks = () => {
        this.syncCallbacks.folders.forEach(callback => callback(this.selectedFolders));
        this.syncCallbacks.documents.forEach(callback => callback(this.selectedDocuments));
    };

    get countSelectedDocuments() {
        return this.selectedDocuments.length;
    }

    get countSelectedFolders() {
        return this.selectedFolders.length;
    }
}